import InventoryRoutes from "./inventory";
import StockTakeRoutes from "./stock-take";
import GridReportRoutes from "./grid-reports";
import CrackingRunRoutes from "./cracking-run";
import InshellRoutes from "./inshell";

export default [
    ...InventoryRoutes,
    ...StockTakeRoutes,
    ...GridReportRoutes,
    ...CrackingRunRoutes,
    ...InshellRoutes,
];
